var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center alert status-state m-0",class:{
		'alert-success': !_vm.serviceStatusIncompleteGroup,
		'alert-warning': _vm.serviceStatusIncompleteGroup
	}},[_vm._v(_vm._s(_vm.status)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }